<div class="footer-wrapper">
  <div class="footer-container">
    <!-- Logo + Copyright -->
    <div class="footer-col footer-col--logo">
      <img class="footer-logo" src="{{skinning.getImage('logo')}}" alt="Logo" />
      <span class="footer-year">{{currentYear}} © {{'operator.name' | transloco}}</span>
      <span class="footer-copyright">{{ 'common.copyright' | transloco }}</span>
      <span class="footer-version">{{'settings.version' | transloco}} {{appVersion}}</span>
    </div>

    <!-- Aviion links -->
    <div class="footer-col">
      <div class="footer-title">{{'operator.name' | transloco}}</div>
      <a class="footer-link" (click)="ux.openTerms()" [analytics]="AnalyticEvent.EventFooterArticle"
        [analyticsData]="{item_category: EventFooterArticleType.Terms}">
        {{'common.menu.terms_of_use' | transloco}}
      </a>
      @if (hasGdpr()) {
        <a class="footer-link" (click)="openGdpr()" [analytics]="AnalyticEvent.EventFooterArticle"
          [analyticsData]="{item_category: EventFooterArticleType.Terms}">
          {{'common.menu.gdpr_rules' | transloco}}
        </a>
      }

      @if (hasCookiePolicy()) {
        <a class="footer-link" (click)="ux.openCookiePolicy()" [analytics]="AnalyticEvent.EventFooterArticle"
          [analyticsData]="{item_category: EventFooterArticleType.Cookie}">
          {{'common.menu.cookies_policy' | transloco}}
        </a>
      }
    </div>

    <!-- Podrška -->
    <div class="footer-col">
      <div class="footer-title"></div>
      <a class="footer-link" (click)="ux.openPrivacy()" [analytics]="AnalyticEvent.EventFooterArticle"
        [analyticsData]="{item_category: EventFooterArticleType.Privacy}">
        {{'common.menu.privacy_policy' | transloco}}
      </a>
      @if (hasPaymentPrivacyAndSecurity()) {
        <a class="footer-link" (click)="ux.openPaymentPrivacyAndSecurity()"
          [analytics]="AnalyticEvent.EventFooterArticle"
          [analyticsData]="{item_category: EventFooterArticleType.Purchase}">
          {{'common.menu.payment_privacy_security' | transloco}}
        </a>
      }
      <div class="footer-inline-links">
        <a class="footer-link" target="_blank" href="{{operator.aboutUrl}}"
          [analytics]="AnalyticEvent.EventFooterArticle"
          [analyticsData]="{item_category: EventFooterArticleType.About}">
          {{ 'common.menu.about_us' | transloco }}
        </a>
        @if (hasImpressum()) {
          <a class="footer-link" (click)="ux.openImpressum()" [analytics]="AnalyticEvent.EventFooterArticle"
            [analyticsData]="{item_category: EventFooterArticleType.Impressum}">
            {{ 'common.menu.impressum' | transloco }}
          </a>
        }
      </div>
    </div>

    <!-- Podrška (pitanja) -->
    <div class="footer-col">
      <div class="footer-title">{{ 'settings.help' | transloco }}</div>
      <a class="footer-link" [routerLink]="'/configuration-center/settings/faq'"
        (click)="scrollToTop()" [analytics]="AnalyticEvent.EventFooterArticle"
        [analyticsData]="{item_category: EventFooterArticleType.FAQ}">
        {{ 'settings.faq' | transloco }}
      </a>
      <a class="footer-link" [routerLink]="'/configuration-center/settings/help'"
        (click)="scrollToTop()" [analytics]="AnalyticEvent.EventFooterArticle"
        [analyticsData]="{item_category: EventFooterArticleType.Contact}">
        {{ 'common.menu.contact_us' | transloco }}
      </a>
    </div>

    <!-- Mobile apps -->
    <div class="footer-col">
      <div class="footer-title">{{'common.download_mobile' | transloco}}</div>
      <div class="footer-store-links">
        @for (link of storeLinks; track link) {
          <a class="footer-store-link" target="_blank" href="{{link.url}}"
            [analytics]="AnalyticEvent.EventFooterArticle" [analyticsData]="{item_category: link.name}">
            <img src="{{link.icon}}" />
            <span>{{ link.localization | transloco }}</span>
          </a>
        }
      </div>
    </div>

    <!-- Social -->
    <div class="footer-col">
      <div class="footer-title">{{ 'common.follow_us' | transloco }}</div>
      <div class="footer-social-links">
        @for (link of socialLinks; track link) {
          <a href="{{link.url}}" target="_blank"
            [analytics]="AnalyticEvent.EventFooterArticle" [analyticsData]="{item_category: link.name}">
            <img src="{{link.icon}}" />
          </a>
        }
      </div>
    </div>
  </div>
</div>